/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseTeaserTileBlockFragment, TeaserTileBlockFragment, FullTeaserTileBlockFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile-block';

/**
 * Get a single TeaserTileBlock by ID (base - scalars only)
 */
export const getBaseTeaserTileBlockById = gql`
  ${BaseTeaserTileBlockFragment}

  query GetBaseTeaserTileBlockById($id: String!, $locale: String!, $preview: Boolean) {
    teaserTileBlock(id: $id, locale: $locale, preview: $preview) {
      ...BaseTeaserTileBlockFragment
    }
  }
`;

/**
 * Get a single TeaserTileBlock by ID (standard - 1 level deep)
 */
export const getTeaserTileBlockById = gql`
  ${TeaserTileBlockFragment}

  query GetTeaserTileBlockById($id: String!, $locale: String!, $preview: Boolean) {
    teaserTileBlock(id: $id, locale: $locale, preview: $preview) {
      ...TeaserTileBlockFragment
    }
  }
`;

/**
 * Get a single TeaserTileBlock by ID (full - 2 levels deep)
 */
export const getFullTeaserTileBlockById = gql`
  ${FullTeaserTileBlockFragment}

  query GetFullTeaserTileBlockById($id: String!, $locale: String!, $preview: Boolean) {
    teaserTileBlock(id: $id, locale: $locale, preview: $preview) {
      ...FullTeaserTileBlockFragment
    }
  }
`;

/**
 * Get all TeaserTileBlock entries with pagination (base - scalars only)
 */
export const getBaseTeaserTileBlocks = gql`
  ${BaseTeaserTileBlockFragment}

  query GetBaseTeaserTileBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TeaserTileBlockOrder]
    $where: TeaserTileBlockFilter
    $preview: Boolean
  ) {
    teaserTileBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseTeaserTileBlockFragment
      }
    }
  }
`;

/**
 * Get all TeaserTileBlock entries with pagination (standard - 1 level deep)
 */
export const getTeaserTileBlocks = gql`
  ${TeaserTileBlockFragment}

  query GetTeaserTileBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TeaserTileBlockOrder]
    $where: TeaserTileBlockFilter
    $preview: Boolean
  ) {
    teaserTileBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...TeaserTileBlockFragment
      }
    }
  }
`;

/**
 * Get all TeaserTileBlock entries with pagination (full - 2 levels deep)
 */
export const getFullTeaserTileBlocks = gql`
  ${FullTeaserTileBlockFragment}

  query GetFullTeaserTileBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TeaserTileBlockOrder]
    $where: TeaserTileBlockFilter
    $preview: Boolean
  ) {
    teaserTileBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullTeaserTileBlockFragment
      }
    }
  }
`;
